import { Theme, styled } from '@material-ui/core';

const TooltipTitleText = styled('div')<Theme>(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(1),
}));

export default TooltipTitleText;
